import InstructionsWrapper from '@cohort/components-xps/components/apps/InstructionsWrapper';
import DefaultInstructions from '@cohort/components-xps/components/apps/youtube/triggers/DefaultInstructions';
import i18nComponentsXpsInstance from '@cohort/components-xps/lib/i18n';
import type {InstructionsComponentProps} from '@cohort/shared/apps/trigger';
import type {YoutubeLikeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/like';
import {Fragment} from 'react';
import {getI18n, useTranslation} from 'react-i18next';

const YoutubeLikeTriggerIntegrationInstructionsComponent: React.FC<
  InstructionsComponentProps<YoutubeLikeTriggerStruct>
> = ({connected, selectedLanguage}) => {
  const {t} = useTranslation('components', {
    keyPrefix: 'apps.youtube.triggers.like',
    lng: selectedLanguage ?? getI18n().language,
    i18n: i18nComponentsXpsInstance,
  });

  return (
    <InstructionsWrapper>
      <ul className="mt-2 list-disc pl-6">
        {connected ? (
          <Fragment>
            <li>
              <p>{t('instructionsStep1')}</p>
            </li>
            <li>
              <p>{t('instructionsStep2')}</p>
            </li>
            <li>
              <p>{t('instructionsStep3')}</p>
            </li>
            <li>
              <p>{t('instructionsStep4')}</p>
            </li>
          </Fragment>
        ) : (
          <DefaultInstructions />
        )}
      </ul>
    </InstructionsWrapper>
  );
};

export default YoutubeLikeTriggerIntegrationInstructionsComponent;
